

import { useState } from 'react';


export default function ComboBox(props)
{       
    

    const [data, setData] = useState(props.array);
    const [class_name, setClassName] = useState(props.css);
   
    const selectOption = (event) => {
        var value = event.target.value;
        props.selectValue({['key']:props.name,['value']:value});
    }

    return (
        <div>
            <select name={props.name} className={class_name} onChange={selectOption} >
                {
                    

                    data.map( (row, ix ) => {

                        if(props.selected==row.key)
                            return (<option selected key={ix} index={ix} value={row.key}  onClick={selectOption}>{row.value}</option>);
                        else
                            return (<option key={ix} index={ix} value={row.key}  onClick={selectOption}>{row.value}</option>);
                    } )
                }   
            </select>
        </div>
    )
 
}